import React from 'react';
import PropTypes from 'prop-types';
import { withTranslate } from 'shared/hocs/withTranslate';

import CommonEmailForm from './CommonEmailForm';

class CarsNameEmailForm extends React.Component {
  static propTypes = {
    userName: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    carLocation: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    changeHandler: PropTypes.func.isRequired,
    onSubmitHandler: PropTypes.func.isRequired,
    disableBtnLeasing: PropTypes.bool,
  };

  static defaultProps = {
    disableBtnLeasing: false,
  };

  handleOptionChange = event => {
    event.stopPropagation();
    if (this.props.changeHandler instanceof Function) {
      this.props.changeHandler('carLocation', event.target.value);
    }
  };

  render() {
    return (
      <CommonEmailForm
        title={this.props.t('Подобрать')}
        disabledBtn={this.props.disableBtnLeasing}
        userName={this.props.userName}
        phone={this.props.phone}
        carLocation={this.props.carLocation}
        errorMessage={this.props.errorMessage}
        successMessage={this.props.successMessage}
        changeHandler={this.props.changeHandler}
        onSubmitHandler={this.props.onSubmitHandler}
      />
    );
  }
}

export default withTranslate(CarsNameEmailForm);



// WEBPACK FOOTER //
// ./src/shared/components/SuggestForDefaultAd/SuggestForm/NameEmailFormMobile.js